import React from 'react';
import { Row, Col } from 'react-bootstrap';
// import { useTranslation } from "react-i18next";
import "./index.scss";


// import OverAllRiskScore from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/OverAllRiskScore";
// import RiskScoreOverTime from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/RiskScoreOverTime";
// import RiskAssessment from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/RiskAssessment";
// import SecurityOverview from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/SecurityOverview";
// import CompromiseIndicators from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/CompromiseIndicator";

import DomainRiskScore from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/DomainRiskScore";
import CyberRate from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/CyberRate";
import DigitalFootPrint from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/DigitalFootprint";
// import RiskRating from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/RiskRating";
import RiskFindings from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/RiskFindings";
import TopTechnologies from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/TopTechnologies";
import TopVulnerabilities from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/TopVulnerabilities";
import SSLExpiry from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/SSLExpiry";
import SSLStatusCard from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/SSLStatusCard";
import BusinessEmailCompromise from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/BusinessEmail";
import AssetMapChart from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/AssetMap";
import VulnerabilityTrend from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/VendorRiskProfile/VulnerabilityTrend";

// import { useScanInfoContext } from "../../../ScanInfo/ScanInfoContext";

const VendorRiskProfile = () => {
    
    // const { domainId, scanId, organizationId } = useScanInfoContext();

    return (
        <>
            <div className="scan-info-main-content">
                <Row>
                    <Col lg={4}>                    
                        {/* <OverAllRiskScore domainId={domainId} scanId={scanId} organizationId={organizationId} /> */}
                        <DomainRiskScore />
                    </Col>
                    <Col lg={8}>
                        {/* <RiskScoreOverTime domainId={domainId} scanId={scanId} organizationId={organizationId} /> */}
                        <CyberRate />
                        <DigitalFootPrint />
                    </Col>
                </Row>
                {/* <RiskRating /> */}
                <RiskFindings />
                <TopTechnologies />
                <div className="mt-4">
                    <Row>
                        <Col lg={5}>
                            <VulnerabilityTrend />
                        </Col>
                        <Col lg={7}>
                            <TopVulnerabilities />
                        </Col>
                    </Row>
                </div>
                <div className="mt-4">
                    <Row>
                        <Col lg={5}>
                            <SSLExpiry />
                        </Col>
                        <Col lg={7}>
                            <SSLStatusCard />
                        </Col>
                    </Row>
                </div>
                <div className="mt-4">
                    <Row>
                        <Col lg={4}>
                            <BusinessEmailCompromise />
                        </Col>
                        <Col lg={8}>
                            <AssetMapChart />
                        </Col>
                    </Row>
                </div>             
                {/* <SecurityOverview domainId={domainId} scanId={scanId} organizationId={organizationId}/>
                <RiskAssessment domainId={domainId} scanId={scanId} organizationId={organizationId} />
                <CompromiseIndicators domainId={domainId} scanId={scanId} organizationId={organizationId}/> */}
            </div>
        </>        
    )
}


export default VendorRiskProfile;